import { DatabaseOutlined, FileDoneOutlined } from '@ant-design/icons';
import { VerticalDivider } from '@remirror/react';
import React from 'react';
import styled from 'styled-components';
import { SearchResultFields_Domain_Fragment } from '../../../../graphql/search.generated';
import { useTranslation } from '../../../../i18n/useTranslation';
import DomainIcon from '../../../domain/DomainIcon';
import { pluralize } from '../../../shared/textUtil';

const Wrapper = styled.div`
    display: flex;
    align-items: center;

    svg {
        margin-right: 4px;
    }
`;

const StyledDivider = styled(VerticalDivider)`
    &&& {
        margin: 0 8px;
    }
`;

interface Props {
    domain: SearchResultFields_Domain_Fragment;
}

export default function DomainEntitiesSnippet({ domain }: Props) {
    const { t } = useTranslation();
    const entityCount = domain.entities?.total || 0;
    const subDomainCount = domain.children?.total || 0;
    const dataProductCount = domain.dataProducts?.total || 0;

    return (
        <Wrapper className="f-text-content f-color-dark-black-s70">
            <DatabaseOutlined aria-label={`${entityCount} ${entityCount === 1 ? t('entity') : t('entities')}`} />
            {entityCount} {entityCount === 1 ? t('entity') : t('entities')}
            <StyledDivider />
            <DomainIcon ariaLabel={`${subDomainCount} ${pluralize(subDomainCount, t('sub-domain'))}`} />
            {subDomainCount} {pluralize(subDomainCount, t('sub-domain'))}
            <StyledDivider />
            <FileDoneOutlined aria-label={`${dataProductCount} ${pluralize(dataProductCount, t('data product'))}`} />
            {dataProductCount} {pluralize(dataProductCount, t('data product'))}
        </Wrapper>
    );
}
